var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsMaintenanceReceptionTimeService, MaintenanceReceptionTimeTemplate } from './maintenance-reception-time.service';
import { Router, ActivatedRoute } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
var KtsMaintenanceReceptionTimeComponent = /** @class */ (function (_super) {
    __extends(KtsMaintenanceReceptionTimeComponent, _super);
    function KtsMaintenanceReceptionTimeComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.rec = new MaintenanceReceptionTimeTemplate();
        _this.maintenance_reception_time = [];
        _this.checked = '';
        return _this;
    }
    KtsMaintenanceReceptionTimeComponent.prototype.ngOninit = function () {
        _super.prototype.ngOnInit.call(this);
        this.getType();
        this.setCompRec();
    };
    KtsMaintenanceReceptionTimeComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsMaintenanceReceptionTimeComponent.prototype.onSubscribe = function (data) {
        this.rec['reception_time'] = data.reception_time;
        this.rec['reception_start_time'] = data.reception_start_time;
        this.rec['reception_end_time'] = data.reception_end_time;
        this.checked = this.rec['reception_time'];
        this.setCompRec();
    };
    KtsMaintenanceReceptionTimeComponent.prototype.getType = function () {
        var _this = this;
        this.service.getType('MAINTENANCE_RECEPTION_TIME').subscribe(function (rec) { return _this.maintenance_reception_time = rec; });
    };
    KtsMaintenanceReceptionTimeComponent.prototype.onEventSubscribe = function (e) {
        this.getType();
    };
    KtsMaintenanceReceptionTimeComponent.prototype.onEvent = function (e1, e2, r) {
        this.rec['reception_time'] = r.code;
        this.checked = r.code;
        this.setCompRec();
    };
    KtsMaintenanceReceptionTimeComponent.prototype.onChange = function (e) {
        this.rec[e.key] = e.val;
        this.setCompRec();
    };
    KtsMaintenanceReceptionTimeComponent.prototype.setCompRec = function () {
        if (this.rec['reception_time'] !== 'specifiedTime') {
            delete this.rec['reception_start_time'];
            delete this.rec['reception_end_time'];
        }
        this.action.setCompRec(this.componentName, this.rec);
    };
    KtsMaintenanceReceptionTimeComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-maintenance-reception-time',
                    template: "<form id=\"{{ componentName }}\">\n  <p><label class=\"-bold\"> {{ (msg | async)['au.COMPONENT.KtsMaintenanceReceptionTimeComponent.label.reception_time'] }} </label></p>\n  <ng-template ngFor let-option [ngForOf]=\"maintenance_reception_time\">\n    <input type=\"radio\" class=\"formInputRadio\" id=\"{{ colKey }}-{{ option.code }}\" (click)=\"onEvent($event, '', option)\" [checked]=\"checked === option.code\">\n    <label for=\"{{ colKey }}-{{ option.code }}\" class=\"formInputRadioLabel\">{{ option.display }}</label>\n    <column *ngIf=\"checked === 'specifiedTime' && option.code === 'specifiedTime'\" [key]=\"'form'\" [col]=\"{\n      items: [{\n        key: 'reception_start_time',\n        controlType: 'time'\n      }, {\n        controlType: 'label',\n        label: ' \uFF5E '\n      }, {\n        key: 'reception_end_time',\n        controlType: 'time'\n      }]\n    }\" [val]=\"rec\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event)\"></column>\n  </ng-template>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsMaintenanceReceptionTimeComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsMaintenanceReceptionTimeService }
    ]; };
    return KtsMaintenanceReceptionTimeComponent;
}(ContentBaseComponent));
export { KtsMaintenanceReceptionTimeComponent };
//# sourceMappingURL=maintenance-reception-time.component.js.map